import { useCallback } from "react"
import { rerandomizeAlbumFromQueue } from "../../actions/randomModeActions"
import { useDispatch } from "react-redux"

export const useRerandomizeRandomQueueItem = (album, queueIndex) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(rerandomizeAlbumFromQueue(album, queueIndex))
    }, [dispatch, album, queueIndex])
}